import * as React from "react";
import type { SVGProps } from "react";
const SvgInvoiceActivity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.33 6V3.33c0-.736.597-1.333 1.334-1.333h5.45c.354 0 .693.14.943.39l1.886 1.887c.25.25.391.589.391.943v7.45c0 .737-.597 1.335-1.334 1.335H4.664a1.334 1.334 0 0 1-1.334-1.334v-1.334"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.335 5.332h-2.668A.667.667 0 0 1 10 4.665V1.998M1.996 8.667h2.591l1.344-2.01 1.786 4.02 1.337-2.01h1.786"
    />
  </svg>
);
export default SvgInvoiceActivity;
